var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button",class:{'button-active':_vm.touchState},on:{"touchstart":_vm.handleTouchstart,"touchend":function($event){return _vm.handleTouchend($event)}}},[_c('span',{staticClass:"button-text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }